<template>
  <v-container fluid class="pa-0 ambiente-transmissao">
    <!-- TELA DE ACESSO -->
    <div v-if="!acessoLiberado" class="tela-acesso">
      <v-row no-gutters>
        <v-col
          cols="12"
          class="d-flex align-center justify-center"
        >
          <div class="text-center px-8">
            <img src="../../assets/logoAICheckinIntelite.png" alt="Logo AiCheckin" width="300px" class="mb-3">

            <p class="descricao-principal mb-4">
              Digite abaixo o código de acesso recebido 
              no WhatsApp após a confirmação da compra.
            </p>
          </div>
        </v-col>

        <v-col
          cols="12"
          class="lado-formulario d-flex align-center justify-center"
        >
          <v-card
            dark
            flat
            color="transparent"
            width="500"
          >
            <v-otp-input
              v-model="codigoAcesso"
              length="6"
              type="text"
              class="otp-custom mb-6"
            />

            <v-btn
              block
              x-large
              color="#5d1aa7"
              class="botao-acesso"
              :loading="loading"
              @click="validarCodigo(codigoAcesso)"
            >
              ACESSAR
            </v-btn>

            <v-alert
              v-if="mensagemErro"
              dense
              outlined
              type="warning"
              class="mt-6"
            >
              {{ mensagemErro }}
            </v-alert>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <!-- ÁREA DA TRANSMISSÃO -->
    <div
      v-else
      class="conteudo-live"
    >
      <!-- TOPO -->
      <div class="topo-live">
        <div class="d-flex align-center">
          <v-avatar color="grey darken-2">
            <v-icon dark>
              mdi-account
            </v-icon>
          </v-avatar>

          <span class="grey--text text--lighten-1 ml-3">
            Olá, {{ inscricao.nome.trim().split(' ')[0] }}!
          </span>
        </div>

        <div class="d-flex align-center">
          <v-btn @click="efetuarLogout" :loading="carregamentoSaida">
            <v-icon left>mdi-exit-to-app</v-icon>
            Sair
          </v-btn>
        </div>
      </div>

      <!-- CONTEÚDO -->
      <div class="pa-4">
        <v-row>
          <!-- PLAYER -->
          <v-col
            cols="12"
          >
            <v-alert type="info">
              Seja muito bem vindo, {{ inscricao.nome.split(' ')[0] }}!
              Seu acesso à transmissão foi liberado com sucesso.
              Por segurança, este código é único e não pode ser compartilhado.
            </v-alert>
          </v-col>
          <v-col
            cols="12"
            lg="8"
          >
            <v-card
              dark
              class="player-card"
            >
              <div class="video-wrapper">
                <iframe
                  :src="videoAtual"
                  frameborder="0"
                  allowfullscreen
                  allow="encrypted-media; accelerometer; autoplay; gyroscope;"
                />
              </div>

              <v-card-text class="pa-6">
                <div class="text-h5 font-weight-bold mb-3">
                  {{ tituloAtual }}
                </div>

                <div class="descricao-video">
                  {{ evento.descricao }}
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- GRAVAÇÕES -->
          <v-col
            cols="12"
            lg="4"
          >
            <v-card
              dark
              class="playlist-card"
            >
              <v-card-title class="text-h5 font-weight-bold">
                Gravações
              </v-card-title>

              <div class="playlist-scroll">
                <div
                  v-for="video in videos"
                  :key="video.id"
                  class="video-item"
                  :class="{ ativo: video.url === videoAtual }"
                  @click="selecionarVideo(video)"
                >
                  <div class="thumb-video d-flex align-center justify-center">
                    <v-icon
                      size="42"
                      color="white"
                    >
                      mdi-play-circle
                    </v-icon>
                  </div>

                  <div class="flex-grow-1 ml-4">
                    <div class="titulo-video-lista">
                      {{ video.titulo }}
                    </div>

                    <div class="subtitulo-video-lista">
                      {{ video.descricao }}
                    </div>
                  </div>

                  <div
                    v-if="video.aoVivo"
                    class="texto-ao-vivo"
                  >
                    ● AO VIVO
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>

    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  import { baseApiUrl } from '@/global'
  import Snackbar from '../../componentes/snackbar.vue'
  import axios from 'axios'
  export default {
    components: { Snackbar },
    data() {
      return {
        loading: false,
        acessoLiberado: false,
        carregamentoSaida: false,
        codigoAcesso: "",
        mensagemErro: "",
        videoAtual: "",
        tituloAtual: "",
        verificaLogin: 0,
        inscricao: {
          nome: "",
          codigoAcesso: "",
          logado: null,
          loginId: null,
        },
        evento: {
          nome: "",
          urlLive: "",
          gravacoes: [],
        },
        videos: []
      };
    },

    async mounted() {
      if (localStorage.getItem('codigoAcesso')) {
        this.codigoAcesso = localStorage.getItem('codigoAcesso')
        localStorage.removeItem('codigoAcesso')
      }

      if (localStorage.getItem('a_cod') && localStorage.getItem('a_lId')) {
        let resposta = await this.verificaAcesso(localStorage.getItem('a_cod'), localStorage.getItem('a_lId'))

        if (resposta) {
          this.validarCodigo(localStorage.getItem('a_cod'))
        }
        else {
          localStorage.removeItem('a_cod')
          localStorage.removeItem('a_lId')
        }
      }
    },

    watch: {
      acessoLiberado(val) {
        if (!val) {
          localStorage.removeItem('a_cod')
          localStorage.removeItem('a_lId')
        }
      },
    },

    beforeDestroy() {
      if (this.verificaLogin) {
        clearInterval(this.verificaLogin)
      }
    },

    methods: {
      async validarCodigo(codigoAcesso) {
        this.loading = true;
        this.mensagemErro = ''

        await axios.post(baseApiUrl + 'inscricoes/inscricaoCodigoAcesso', {codigoAcesso: codigoAcesso})
        .then(response => {
          if (!response.data.transmissaoAtiva) {
            this.mensagemErro = response.data.mensagem
            return
          }

          this.inscricao = response.data.inscricao;
          this.evento = response.data.evento;
          localStorage.setItem("a_cod", codigoAcesso)
          localStorage.setItem("a_lId", this.inscricao.loginId)
          this.acessoLiberado = true;

          this.verificacaoLogin()
          this.montaListaVideos(this.evento, response.data.transmissaoAtiva)
        })
        .catch(error => {
          if (error.response.data.error.mensagem)
            this.mensagemErro = error.response.data.error.mensagem
          else
            this.mensagemErro = error.response.data.error.message
        })

        this.loading = false;
      },

      async verificaAcesso(codigoAcesso, loginId) {
        let resposta = null

        await axios.post(baseApiUrl + 'inscricoes/verificaLoginCodigoAcesso', { codigoAcesso: codigoAcesso, loginId: loginId})
        .then(response => {
          resposta = response.data.ativo
        })
        .catch(() => {
          resposta = false
        })

        return resposta
      },

      async efetuarLogout() {
        let codigoAcesso = localStorage.getItem('a_cod')
        let loginId = localStorage.getItem('a_lId')
        this.carregamentoSaida = true;

        await axios.post(baseApiUrl + 'inscricoes/logoutCodigoAcesso', { codigoAcesso: codigoAcesso, loginId: loginId})
        .then(() => {
          this.acessoLiberado = false;

          if (this.verificaLogin) {
            clearInterval(this.verificaLogin)
          }
        })
        .catch(() => {
          this.$refs.chamaSnackbar.snack("#FF0000", "Problema ao sair do acesso. Tente novamente.","DESCULPE");
        })

        this.carregamentoSaida = false;
      },

      verificacaoLogin() {
        let codigoAcesso = localStorage.getItem('a_cod')
        let loginId = localStorage.getItem('a_lId')

        this.verificaLogin = setInterval(async () => {
          let resposta = await this.verificaAcesso(codigoAcesso, loginId)

          if (resposta == false) {
            clearInterval(this.verificaLogin)
            this.$refs.chamaSnackbar.snack("#FF0000", "Desconectado por acesso em outro dispositivo", "ATENÇÃO")
            this.acessoLiberado = false
          }
        }, 60000)
      },

      selecionarVideo(video) {
        this.videoAtual = video.url;
        this.tituloAtual = video.titulo;
      },

      montaListaVideos(evento, transmissaoAtiva) {
        let videos = []

        if (transmissaoAtiva) {
          videos.push({
            titulo: evento.nome,
            url: evento.urlLive,
            aoVivo: true,
          })
        }

        if (evento.gravacoes.length > 0) {
          evento.gravacoes.forEach(gravacao => {
            videos.push(gravacao)
          });
        }

        this.videos = videos
        this.selecionarVideo(this.videos[0]);
      },

      converterYoutube(url) {
        let videoId = url.split("v=")[1]

        return `https://www.youtube.com/embed/${videoId}`
      },
    }
  };
</script>

<style scoped>
.ambiente-transmissao {
  min-height: 100vh;
  background: #0f0f0f;;
  color: white;
}

/* TELA DE ACESSO */

.tela-acesso {
  min-height: 100vh;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;

  overflow-x: hidden;

  padding: 40px;
}

.live-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #e11d48;
  border-radius: 8px;
  padding: 8px 18px;
  font-weight: bold;
  font-size: 14px;
}

.descricao-principal {
  font-size: 20px;
  color: rgba(255,255,255,0.7);
  max-width: 500px;
  margin: auto;
  line-height: 1.7;
}

.botao-acesso {
  height: 60px !important;
  font-size: 18px;
  font-weight: bold;
  border-radius: 12px;
}

/* TOPO */

.topo-live {
  height: 90px;
  border-top: 1px solid rgba(255,255,255,0.08);
  border-bottom: 1px solid rgba(255,255,255,0.08);
  padding: 0 24px;

  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ao-vivo-indicador {
  color: #ff4d4d;
  font-size: 14px;
  font-weight: bold;
}

/* PLAYER */

.player-card,
.playlist-card {
  background: #181818 !important;
  border: 1px solid #242424;
  border-radius: 0px !important;
  overflow: hidden;
}

.video-wrapper {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  background: black;
}

.video-wrapper iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.descricao-video {
  color: rgba(255,255,255,0.7);
  line-height: 1.8;
}

/* PLAYLIST */

.playlist-scroll {
  max-height: 900px;
  overflow-y: auto;
}

.video-item {
  display: flex;
  align-items: center;
  padding: 18px;
  cursor: pointer;
  transition: 0.2s;
  border: 1px solid transparent;
}

.video-item:hover {
  background: rgba(255,255,255,0.04);
}

.video-item.ativo {
  border: 1px solid rgba(239,68,68,0.8);
  background: rgba(239,68,68,0.05);
}

.thumb-video {
  min-width: 160px;
}

.titulo-video-lista {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 8px;
}

.subtitulo-video-lista {
  color: rgba(255,255,255,0.6);
}

.texto-ao-vivo {
  color: #ff4d4d;
  font-weight: bold;
  font-size: 14px;
  white-space: nowrap;
}

/* RODAPÉ */

.rodape-live {
  border-top: 1px solid rgba(255,255,255,0.08);
  margin-top: 30px;
  padding: 24px;
  color: rgba(255,255,255,0.5);
}

/* MOBILE */

@media (max-width: 960px) {
  .tela-acesso {
    padding: 40px 20px;
  }

  .tela-acesso .row {
    flex-direction: column;
    margin: 0 !important;
  }

  .lado-formulario {
    padding: 0;
  }

  .descricao-principal {
    text-align: center;

    font-size: 18px;

    max-width: 100%;
  }

  .botao-acesso {
    width: 100%;
  }
}

@media (max-width: 600px) {
  .descricao-principal {
    font-size: 16px;
  }

  .v-otp-input input {
    width: 42px !important;
    height: 52px !important;
    font-size: 20px !important;
  }

  .topo-live {
    padding: 16px;
  }

  .video-wrapper {
    border-radius: 14px 14px 0 0;
    overflow: hidden;
  }

  .thumb-video {
    height: 180px !important;
  }

  .lado-formulario {
    width: 100%;
    max-width: 100%;
  }

  .lado-formulario .v-card {
    width: 100% !important;
    max-width: 100% !important;
  }
}
</style>